// import Letter from 'components/animations/Letter';
import Letter from "./Letter";
import Highlighter from "./Highlighter";
import FromDirection from "./FromDirection";
import Reveal from "./Reveal";
import FadeIn from "./FadeIn";
import StaggerChildren from "./StaggerChildren";
import ParallaxSection from "./ParallaxSection";
import PageTransition from "./PageTransition";

const Animated = {
  Letter,
  Highlighter,
  FromDirection,
  Reveal,
  FadeIn,
  StaggerChildren,
  ParallaxSection,
  PageTransition,
};

export default Animated;
